import React, { useEffect, useState } from "react";
import HubViewCard from "./HubGeneralInfoCard";
import hubsService from "services/hubsService";
import { Grid } from "@mui/material";
import { HubResult } from "hubs/models";
import { useParams, useNavigate } from "react-router-dom";
import HubEditCard from "./HubEditCard";
import HubDetailsCard from "./HubDetailsCard";
import ClientList from "./HubClientList";

const Hub = () => {
  const { id } = useParams();
  const [hub, setHub] = useState<HubResult>();
  const [isLoading, setIsLoading] = useState(true);
  const [isEdit, setIsEdit] = useState(false);
  useEffect(() => {
    getHub();
  }, []);

  const getHub = () => {
    hubsService
      .getHub(+id!)
      .then((result) => setHub(result))
      .finally(() => setIsLoading(false));
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <HubViewCard hub={hub} isLoading={isLoading} />
        </Grid>
        <Grid item xs={12} md={6}>
          {isEdit ? (
            <HubEditCard hub={hub} setHub={setHub} getHub={getHub} isLoading={isLoading} setIsEdit={setIsEdit} />
          ) : (
            <HubDetailsCard hub={hub} isLoading={isLoading} setIsEdit={setIsEdit} />
          )}
        </Grid>
        <Grid item xs={12}>
          <ClientList id={id} clients={hub?.clients ?? []} isLoading={isLoading} getHub={getHub} />
        </Grid>
      </Grid>
    </>
  );
};
export default Hub;
